import React from "react";
import AppRouter from "./AppRouter";
import './App.css'; // Your main stylesheet

export default function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}